<template>
  <b-container fluid>
    <b-overlay :show="loading">
    <b-row>
      <b-col lg="10" sm="10" offset-lg="1">
        <iq-card>
          <template v-slot:body>
            <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                <b-form  @submit.prevent="handleSubmit(saveData)" @reset.prevent="reset">
                    <b-row>
                        <b-col lg="12" sm="12">
                            <table class="table table-sm table-bordered">
                                <tr>
                                    <td>{{ $t('externalUser.amount') }}</td>
                                    <td>{{ formData.amount }} <span>Tk</span></td>
                                </tr>
                                <tr v-if="formData.is_partial">
                                    <td>{{ $t('externalUser.partial_amount') }} <span class="text-danger">*</span></td>
                                    <td>
                                        <ValidationProvider name="Partial Amount" vid='partial_amount' rules='required'>
                                            <b-form-group
                                                slot-scope="{ valid, errors }"
                                            >
                                                <b-form-input
                                                id="partial_amount"
                                                type="number"
                                                @keyup="checkAmount()"
                                                v-model.number="formData.partial_amount"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                ></b-form-input>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </td>
                                </tr>
                                <tr v-if="formData.is_partial">
                                    <td>{{ $t('externalUser.total_due') }}</td>
                                    <td>{{ (parseFloat(formData.amount) - parseFloat(formData.partial_amount) > 0) ? (parseFloat(formData.amount) - parseFloat(formData.partial_amount)) : 0 }} <span>Tk</span></td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td class="">
                                        <b-button type="submit" variant="primary" class="mr-2">{{ $t('globalTrans.payment') }}</b-button>
                                    </td>
                                </tr>
                            </table>
                        </b-col>
                    </b-row>
                </b-form>
            </ValidationObserver>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-overlay>
  </b-container>
</template>
<style lang="scss" scoped>
    .form-for-textarea textarea{ line-height: 18px !important;height: 54px !important; }
    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    /* Firefox */
    input[type=number] {
      -moz-appearance: textfield;
    }
</style>

<script>
import { core } from '@/config/pluginInit'
import { ValidationObserver } from 'vee-validate'
import RestApi, { productionServiceBaseUrl } from '@/config/api_config'
import { onlineOrderPaymentEntry } from '../../../api/routes'

export default {
  props: ['payment'],
  components: {
    ValidationObserver
  },
  data () {
    return {
      saveBtnName: this.$t('globalTrans.save'),
      loading: false,
      formData: {
        amount: 0,
        partial_amount: ''
      }
    }
  },
  computed: {},
  created () {
    if (this.payment) {
        const tmp = Object.assign({}, this.formData, this.payment)
        const tmp2 = Object.assign(tmp, { amount: this.getDueGrandTotal(this.payment) })
        this.formData = tmp2
    }
  },
  mounted () {
    core.index()
  },
  methods: {
    checkAmount () {
        if (parseFloat(this.formData.partial_amount) > parseFloat(this.formData.amount)) {
            this.formData.partial_amount = this.formData.amount
        }
    },
    async saveData () {
        this.$store.dispatch('mutateCommonProperties', { loading: true })
        let result = null
        const loadingState = { loading: false, listReload: false }
        this.loading = true
        if (this.payment) {
            result = await RestApi.postData(productionServiceBaseUrl, onlineOrderPaymentEntry, this.formData)
        }

        loadingState.listReload = true
        this.$store.dispatch('mutateCommonProperties', loadingState)
        this.loading = false
        if (result.success) {
            this.$store.commit('ProductionService/mutateCommonObj', { hasDropdownLoaded: false })
            this.$toast.success({
                title: this.$t('globalTrans.success'),
                message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                color: '#D6E09B'
            })
            window.location = result.url
            this.$bvModal.hide('modal-receive')
        } else {
            this.$toast.error({
                title: this.$t('globalTrans.error'),
                message: result.message,
                color: '#D6E09B'
            })
            this.$refs.form.setErrors(result.errors)
        }
    },
    getDueGrandTotal (tmp) {
      const result = tmp.paymentList.reduce((total, item) => total + parseFloat(item.due_amount), 0)
      const total = parseFloat(result)
      return total
    }
  }
}
</script>
